import { Button, Card, Col, List, PageHeader, Row } from "antd";
import Search from "antd/lib/input/Search";
import moment from "moment";
import React from "react";


import { IAppContext, withAppContext } from '../AppContext'
import { RouteComponentProps, withRouter } from "react-router";
import { LicenzeProjection } from "../../models/Licenza";
import { PagedBaseState } from "../../models/PagedBaseState";
import { SearcherBaseModel } from "../../models/SearcherBaseModel";
import { ILicenzeService } from "../../services/LicenzeService";
import { ISignalRServiceHandler } from "../../services/shared/SignalRServiceHandler";
import container from "../../wires/Bootstrapper";
import SERVICE_IDENTIFIER from "../../wires/Identifiers";
import { TTAvatarLicenza } from "./TTAvatarLicenza";
import { withAITracking } from '@microsoft/applicationinsights-react-js'
import { ai } from '../../TelemetryService'
import { SaveOutlined } from "@ant-design/icons";

export class PageLicenze extends React.Component<any, PagedBaseState<LicenzeProjection>> {

    service: ILicenzeService
    signalRService: ISignalRServiceHandler;

    constructor(props) {
        super(props)
        this.state = new PagedBaseState <LicenzeProjection>()
        this.service = container.get(SERVICE_IDENTIFIER.LICENZE_SERVICE);
    }

    componentDidMount() {
        this.search(1)
        //this.signalRService.AddEventHandlerFor('LicenseRecieved', this.onLicenseReceived);
    }

    componentWillUnmount() {
        //this.signalRService.RemoveEventHandlerFor('LicenseRecieved', this.onLicenseReceived);
    }

    navigate = (item: LicenzeProjection) => {
        this.props.history.push(`/LicenzaClienti/${item.LicenzaId}`)
    }

    onLicenseReceived = () => {
        this.service.Render().then(resp => {
            this.setState(resp)
        })
    }

    buy = () => {
        //this.service.CompraLicenza().then(it => {
        //    if (it.IsValid) {
        //        debugger
        //        window.open(it.UrlPagamento)
        //    }
        //})
    }

    search = (page: number) => {
        let searcher: SearcherBaseModel = {
            Righe: 10,
            Pagina: page,
            FullText: this.state.Searcher
        }
        this.service.Search(searcher).then(it => this.setState({ Data: it, Page: page }))
    }

    render() {
        const { Data } = this.state
        return (
            <>
            <PageHeader title="" style={{ paddingTop: '0px' }} extra={[
                <Button type="primary" key="save" icon={<SaveOutlined />} onClick={() => this.buy()}>Acquista Licenza</Button>
            ]}></PageHeader>
            <Card bordered={false} title="Seleziona una licenza per continuare">
                <Row>
                    <Col offset={1} span={22}>
                        <Search
                            placeholder="Cerca licenza per chiave"
                            onChange={e => this.setState({ Searcher: e.target.value })}
                            onSearch={value => this.search(1)}
                            value={this.state.Searcher}
                            enterButton />
                    </Col>
                </Row>
                <br />
                <List
                    dataSource={Data.Data}
                    pagination={{
                        onChange: (page) => this.search(page),
                        pageSize: 10,
                        total: this.state.Data.Total,
                        showTotal: (total) => `${total} elementi`,
                        current: this.state.Page,
                        size:"small"
                    }}
                    renderItem={item => (
                        <List.Item key={item.Id}>
                            <List.Item.Meta
                                avatar={<TTAvatarLicenza clientiRimanenti={item.ClientiRimanenti} stato={item.Stato} />}
                                title={<a onClick={() => this.navigate(item)}>{`Licenza per ${item.NumeroClienti} clienti`}</a>}
                                description={`Scadenza ${moment(item.Scadenza).format('L')} - ${item.ClientiRimanenti} disponibili`}
                            />
                        </List.Item>
                    )}
                />
                </Card>
            </>
        )
    }
}

export const Licenze = withAITracking(ai.reactPlugin, withRouter(PageLicenze), "Licenze")
